<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    computed: mapGetters({
        company: 'company',
        options: 'services',
        packets: 'packets',
        services: 'services',
    }),
}
</script>

<template lang="pug">
acrm-panel
    acrm-user-packet-prices
</template>
